import { StatusBadge } from "./StatusBadge";
import { Wifi, WifiOff, Clock } from "lucide-react";

interface SCADAHeaderProps {
  wellName: string;
  location?: string;
  date: string;
  status: "draft" | "queued" | "synced" | "locked" | "error" | "offline";
  isOnline?: boolean;
  pendingSyncCount?: number;
}

export function SCADAHeader({
  wellName,
  location,
  date,
  status,
  isOnline = true,
  pendingSyncCount = 0,
}: SCADAHeaderProps) {
  return (
    <div className="bg-card border-b border-border px-4 py-3 md:px-6 md:py-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        {/* Left: Well Info */}
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground">
            {wellName}
          </h1>
          {location && (
            <p className="text-sm text-muted-foreground">{location}</p>
          )}
        </div>

        {/* Right: Status Indicators */}
        <div className="flex flex-wrap items-center gap-3">
          {/* Date */}
          <div className="flex items-center gap-2 text-sm">
            <Clock className="w-4 h-4 text-muted-foreground" />
            <span className="font-mono text-foreground">{date}</span>
          </div>

          {/* Online/Offline */}
          <div className="flex items-center gap-2">
            {isOnline ? (
              <>
                <Wifi className="w-4 h-4 text-green-400" />
                <span className="text-xs text-green-400 font-mono">ONLINE</span>
              </>
            ) : (
              <>
                <WifiOff className="w-4 h-4 text-gray-400" />
                <span className="text-xs text-gray-400 font-mono">OFFLINE</span>
              </>
            )}
          </div>

          {/* Pending Sync Count */}
          {pendingSyncCount > 0 && (
            <div className="bg-amber-900/40 text-amber-400 px-2 py-1 rounded text-xs font-mono border border-amber-700">
              {pendingSyncCount} PENDING
            </div>
          )}

          {/* Status Badge */}
          <StatusBadge status={status} />
        </div>
      </div>
    </div>
  );
}
